import React from 'react';
import PropTypes from 'prop-types';
import RangePickerHOC from 'components/widgets/dateRangePicker';
import moment from 'moment';
import momentPropTypes from 'react-moment-proptypes';

const RangePicker = (props) => {
    const {
        startDate,
        endDate,
        startLabel,
        endLabel,
        startDateId,
        endDateId,
        startDatePlaceholderText,
        endDatePlaceholderText,
        onFocus,
        onTimeChange,
        showCalendar,
    } = props;

    moment.locale(window.Locale);

    const times = [
        { value: 0, text: '12:00 am' },
        { value: 1, text: '1:00 am' },
        { value: 2, text: '2:00 am' },
        { value: 3, text: '3:00 am' },
        { value: 4, text: '4:00 am' },
        { value: 5, text: '5:00 am' },
        { value: 6, text: '6:00 am' },
        { value: 7, text: '7:00 am' },
        { value: 8, text: '8:00 am' },
        { value: 9, text: '9:00 am' },
        { value: 10, text: '10:00 am' },
        { value: 11, text: '11:00 am' },
        { value: 12, text: '12:00 pm' },
        { value: 13, text: '1:00 pm' },
        { value: 14, text: '2:00 pm' },
        { value: 15, text: '3:00 pm' },
        { value: 16, text: '4:00 pm' },
        { value: 17, text: '5:00 pm' },
        { value: 18, text: '6:00 pm' },
        { value: 19, text: '7:00 pm' },
        { value: 20, text: '8:00 pm' },
        { value: 21, text: '9:00 pm' },
        { value: 22, text: '10:00 pm' },
        { value: 23, text: '11:00 pm' },
    ];

    return (
        <div className="row gutter-0">
            <div className="col-md col-6">
                <div className="cldr_container single-date-picker">
                    <div>
                        <div>
                            <div className="d-flex">
                                <button className="date-picker-btn col text-left pr-0" type="button" id={startDateId} onClick={(e) => { onFocus('startDate'); showCalendar(e); }}>
                                    <span className="text-label">{startLabel}</span>
                                    {(startDate && startDate.format('MM/DD/YYYY')) || startDatePlaceholderText}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md col-6">
                <div className="input-chevron-down">
                    <div className="element-wrapper select-unstyled-container">
                        <label className="text-label" htmlFor="flt_departTime">Time</label>
                        <select
                            id="flt_departTime"
                            value={startDate !== null ? parseInt(startDate.format('H'), 10) : null}
                            onChange={(event) => onTimeChange(event.target.value, 'start')}
                            className="select-unstyled pr-0"
                        >
                            {times.map((timeOption) => (
                                <option value={timeOption.value}>{timeOption.text}</option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
            <div className="col-md col-6">
                <div className="cldr_container single-date-picker">
                    <div>
                        <div>
                            <div className="d-flex">
                                <button className="date-picker-btn col text-left left-border pr-0" type="button" id={endDateId} onClick={(e) => { onFocus('endDate'); showCalendar(e); }}>
                                    <span className="text-label">{endLabel}</span>
                                    {(endDate && endDate.format('MM/DD/YYYY')) || endDatePlaceholderText}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md col-6">
                <div className="input-chevron-down">
                    <div className="element-wrapper select-unstyled-container">
                        <label className="text-label" htmlFor="flt_returnTime">Time</label>
                        <select
                            id="flt_returnTime"
                            value={endDate !== null ? parseInt(endDate.format('H'), 10) : null}
                            onChange={(event) => onTimeChange(event.target.value, 'end')}
                            className="select-unstyled pr-0"
                        >
                            {times.map((timeOption) => (
                                <option value={timeOption.value}>{timeOption.text}</option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
        </div>
    );
};

RangePicker.propTypes = {
    startDate: momentPropTypes.momentObj,
    endDate: momentPropTypes.momentObj,
    departTime: PropTypes.object,
    returnTime: PropTypes.object,
    onTimeChange: PropTypes.func,
    startDatePlaceholderText: PropTypes.string,
    endDatePlaceholderText: PropTypes.string,
    startDateId: PropTypes.string.isRequired,
    endDateId: PropTypes.string.isRequired,
    startLabel: PropTypes.string,
    endLabel: PropTypes.string,
    onFocus: PropTypes.func.isRequired,
    showCalendar: PropTypes.func.isRequired,
};

RangePicker.defaultProps = {
    startDate: null,
    endDate: null,
    startLabel: 'Departure',
    endLabel: 'Return',
    startDatePlaceholderText: 'Departure',
    endDatePlaceholderText: 'Return',
};

export default RangePickerHOC(RangePicker);
